// extracted by mini-css-extract-plugin
module.exports = {"also-read":"_1a5aS","title":"_1Jj4B","content":"_2FuPS"};